<template>
	<div class="Service">
		<div class="banner">
			<div class="content">
				<div class="content_2">
					<div class="banner_img">
						<img src="../assets/Service.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="content_2">
				<!-- <div class="banner_title ls2" style="padding-top: 0;">服务流程图</div>
				<div class="banner_title_e ls2">SERVICE PROCESS PICTURE</div> -->
				<div class="f30 lh7 tz">智能化服务流程</div>
				<div class="f20 lh7 tz">INTELLIGENT SERVICE PROCESS</div>
				<div class="tz Service_content">
					<img src="../assets/Service_content_4.png" @click="$store.state.mobile ? look(require('../assets/Service_content_4.png')) : ''" />
				</div>
				
				<div class="f30 lh7 tz">信息化服务流程</div>
				<div class="f20 lh7 tz">INFORMATION SERVICE PROCESS</div>
				<div class="tz Service_content">
					<img src="../assets/Service_content_2.png" @click="$store.state.mobile ? look(require('../assets/Service_content_2.png')) : ''" />
					<img src="../assets/Service_content_3.png" @click="$store.state.mobile ? look(require('../assets/Service_content_3.png')) : ''" />
				</div>
				
				<div class="f30 lh7 tz">物流服务流程</div>
				<div class="f20 lh7 tz">SERVICE PROCESS</div>
				<div class="tz Service_content">
					<img src="../assets/Service_content_1.png" @click="$store.state.mobile ? look(require('../assets/Service_content_1.png')) : ''" />
				</div>
				<div class="pb40"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			look(url) {
				window.open(url)
			}
		}
	}
</script>

<style lang="scss">
	.Service {
		overflow: hidden;
		
		.banner {
			height: 360px;
			position: relative;
			background: url(../assets/About_banner_FWLN.jpg) no-repeat center;
			margin-bottom: 75px;
			@media screen and (max-width: 768px) {
				height: 220px;
				background-size: cover;
				margin-bottom: 40px;
			}
		}
		
		.Service_content {
			margin-bottom: 40px;
			img {
				max-width: 100%;
				margin: 100px 0 40px;
				@media screen and (max-width: 768px) {
					margin: 25px 0 40px;
				}
			}
		}
		
		@media screen and (max-width: 768px) {
			.f30 {
				font-size: 7vw;
				line-height: 1.2;
				text-align: center;
				margin-bottom: 20px;
			}
			
			.f20 {
				font-size: 16px;
				text-align: center;
				line-height: 1.2;
				margin-bottom: 30px;
			}
			
			.f18 {
				font-size: 16px;
			}
			
			img {
				margin: 25px 0 40px;
				padding: 0 2vw;
				box-sizing: border-box;
			}
		}
	}
</style>
